//import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

//@Injectable()

export class Globals {
/*  readonly BASE_URL_AUTH: string = 'https://wsopa.uaa.mx:450/api/infraestructura/autenticaExt/';
  readonly BASE_URL: string = 'https://wsopa.uaa.mx:450/api/finanzas/compras/';
  readonly BASE_URL_PROCS: string =  'https://wsopa.uaa.mx:450/api/finanzas/compras/procedimientos/';
  readonly BASE_URL_UTILERIAS: string = 'https://wsopa.uaa.mx:450/'; // this.BASE_SERVER; // + 'https://localhost:5001/';
  readonly BASE_URL_RESTABLECE: string = 'https://adquisicionesyobrapublica.uaa.mx/restablecer-contrasena/';
  readonly BASE_URL_REPORTE: string = 'https://wsreportes.uaa.mx:452/';
*/
  readonly BASE_URL_AUTH: string = environment.apiUrl450 + '/api/infraestructura/autenticaExt/';
  readonly BASE_URL: string =  environment.apiUrl450 + '/api/finanzas/compras/';
  readonly BASE_URL_PROCS: string =  environment.apiUrl450 + '/api/finanzas/compras/procedimientos/';
  readonly BASE_URL_UTILERIAS: string = environment.apiUrl450 + '/'; // this.BASE_SERVER; // + 'https://localhost:5001/';
  readonly BASE_URL_RESTABLECE: string = environment.apiUrl453 + '/#/restablecer-contrasena/';
  readonly BASE_URL_VERIFICA: string = environment.apiUrl453 + '/#/verificar/';
  readonly BASE_URL_REPORTE: string = environment.apiUrl452 + '/';

  /*Constante de Tipos de Procedimiento*/
  public TIPO_PROC_SERVICIOS: string = '2';     // Productos y Servicios
  public TIPO_PROC_OBRA: string = '4';          // Obra Publica

  /*Constante de Estus de Proceso por Proveedor*/
  public ESTATUS_PROC_PROV_INTERES: string = '0';           // Mostro interes
  public ESTATUS_PROC_PROV_PARTICIPANDO: string = '1';      // Participando
  public ESTATUS_PROC_PROV_ENVIO_PROPUESTA: string = '2';   // Envió Propuesta
  public ESTATUS_PROC_PROV_DECLINO: string = '4';           // Declinó
  public ESTATUS_PROC_PROV_DESCARTO_UAA: string = '3';      // Descartó la propuesta UAA
  public ESTATUS_PROC_PROV_ADJUDICADO: string = '5';        // Adjudicado

  public ESTATUS_DESC_PROC_PROV_INTERES: string = 'MOSTRÓ INTERES';         // Mostro interes
  public ESTATUS_DESC_PROC_PROV_PARTICIPANDO: string = 'PARTICIPANDO';      // Participando

  /*Estus de Proceso*/
  public ESTATUS_PROC_GENERADO: string = '0';         // Generado
  public ESTATUS_PROC_VOBO_JEFE: string = '1';        // Vobo Jefe Depto.
  public ESTATUS_PROC_VOBO_DIRECCION: string = '2';   // Vobo Dirección
  public ESTATUS_PROC_PUBLICADO: string = '3';        // Publicado
  public ESTATUS_PROC_POR_ADJUDICAR: string = '4';    // Por Adjudicar
  public ESTATUS_PROC_ADJUDICADO: string = '5';       // Adjudicado
  public ESTATUS_PROC_CONCLUIDO: string = '6';        // Concluido
  public ESTATUS_PROC_SUSPENDIDO: string = '7';       // Suspendido
  public ESTATUS_PROC_DESIERTO: string = '8';         // Desierto
  public ESTATUS_PROC_CANCELADO: string = '99';       // Cancelado


  /*Estatus Proveedor */
  public ESTATUS_PREREGISTRADO: string = '0';         //Preregistrado
  public ESTATUS_CAP_FINALIZADA: string = '1';        //Captura Finalizada
  public ESTATUS_DOC_REVISADOS: string = '2';         //Documentos Revisados
  public ESTATUS_ACTIVO: string = '3';                //Activo
  public ESTATUS_REFRENDO: string = '4';              //Refrendo Anual
  public ESTATUS_DOCPEND: string = '5';               //Documentacion Pendiente
  public ESTATUS_REFCOMP: string = '6';               //Refrendo Anual Completo


  /*TIPO MOVTO. FACTURAS EN: PKG_F_FGFCEPR.PRO_ABCDOCUMENTOS*/
  public readonly MOVTO_ALTA_FACTURA: string = '1';
  public readonly MOVTO_BORRAR_FACTURA: string = '2';

  /*IACTIDOS DE PROCESOS*/
  public readonly IACTIDO_PROC_ADQUISICION: string = 'ADQUISICION'; //Adquisición
  public readonly IACTIDO_PROC_OBRA: string = 'OBRAPUB';            //Obra Pública

  /*INDICADOR PARA TIPO ORDENES DE COMPRA*/
  public readonly IND_ORDEN_LICITACIONES: string = 'L';      //Tipo Licitaciones
}
